<template>

<div class="row">

	<div class="col-md-12" v-if="dataReady">

		<div class="card">
			<div class="card-block text-center">
				<h4 class="card-title">{{$t('label.invited_by')}} {{invitation.family.name}}</h4>

				<button type="button" class="btn btn-primary" @click="acceptInvitation()">{{$t('label.accept')}}</button>
				<button type="button" class="btn btn-default" @click="declineInvitation()">{{$t('label.decline')}}</button>
			</div>
		</div>

	</div>
</div>

</template>

<script>

module.exports = {
	data: function () {
		return {
			invitation: {},
			dataReady: false
		};
	},
	computed: {
		usersByRole: function () {
			var roles = {
				child: [],
				mother: [],
				father: [],
				son: [],
				daughter: []
			};
			for (var i = 0; i < this.family.users.length; i++) {
				var member = this.family.users[i];
				if (member.role === 'son' || member.role === 'daughter') {
					roles.child.push(member);
				}
				roles[member.role].push(member);
			}
			return roles;
		}
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function () {
			this.$http.get('backend://family/' + this.$route.params.family + '/invite/' + this.$route.params.token).then((result) => {
				this.invitation = result.body;
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},
		acceptInvitation: function () {
			this.$http.post('backend://family/' + this.$route.params.family + '/invite/' + this.$route.params.token, {}).then((response) => {
				this.$user.refresh().then(() => {
					this.$router.push('/');
				});
			}).catch(this.$http.toastCatcher);
		},
		declineInvitation: function () {
			this.$http.delete('backend://family/' + this.$route.params.family + '/invite/' + this.$route.params.token).then((response) => {
				this.$toasted.show('Успешно отказахте поканата.').goAway(1500);
				this.$router.push('/registration');
			}).catch(this.$http.toastCatcher);
		}
	}
};
</script>
<style>
.hs_method {
	border-bottom: 2px solid #eee;
	padding: 7px;
}
.card-sub-title {
 margin-top: 20px;
}
.wizard-page {
	margin: 3rem 0;
}
</style>



// WEBPACK FOOTER //
// Invitation.vue?6ad2b3e9